/**
 * @deprecated use marketplace-ui-common
 */
export const debounce = (fn, time = 250) => {
  let timeoutId;
  return (...args) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(() => {
      timeoutId = null;
      fn(...args);
    }, time);
  };
};